import * as React from 'react';
import * as main from '../../main.module.scss';
import * as decide from './style.module.scss';
export const Decide = () => {
  return (
    <section className={decide.decide}>
      <div className="container">
        <div className={decide.container}>
          <h2 className={main.title}>
            Сегодня <span className={main.violet}>вы решаете</span> кем будете завтра
          </h2>
          <ul className={decide.mainList}>
            <li>
              <img
                src="https://fs.advance.ru/landing-pages/marathon/marafon_motivacii_i_obuchenija_detej_2025/chel-razv.png"
                alt=""
              />
              <div className={decide.info}>
                <h3>Человек развития:</h3>
                <ul className={decide.innerList}>
                  <li>Много учится</li>
                  <li>Развивается в любом интересном ему направлении</li>
                  <li>Не боится сложных задач</li>
                  <li>Способен маленькими шагами идти к большой цели</li>
                  <li>Повышает свое мастерство каждый день</li>
                  <li>Легко воспринимает критику и сам ищет обратную связь</li>
                  <li>Разрешает себе ошибаться</li>
                  <li>В каждой трудности видит возможности</li>
                  <li>Уверен в себе</li>
                </ul>
              </div>
            </li>
            <li>
              <img
                src="https://fs.advance.ru/landing-pages/marathon/marafon_motivacii_i_obuchenija_detej_2025/chel-zast.png"
                alt=""
              />
              <div className={decide.info}>
                <h3>Человек застоя:</h3>
                <ul className={decide.innerList}>
                  <li>Давно не учился</li>
                  <li>Вместо развития получает только обязательные «корочки» без знаний</li>
                  <li>Избегает сложных и новых задач</li>
                  <li>Быстро сдается даже на простых задачах</li>
                  <li>Теряет навыки и ценность как работник</li>
                  <li>Болезненно переносит критику и обратную связь</li>
                  <li>Часто ошибается и пытается скрыть ошибки</li>
                  <li>В каждой возможности видит трудности</li>
                  <li>Страдает синдромом самозванца и неуверенностью в себе</li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <div className={decide.learn}>
          <div className={decide.learnInfo}>
            <h3>За 5 дней вы&nbsp;узнаете</h3>
            <p>
              что ваш мозг способен на большее,
              <br /> надо просто знать правильный подход
            </p>
          </div>
          <img
            src="https://fs.advance.ru/landing-pages/marathon/marafon_motivacii_i_obuchenija_detej_2025/yourbrain.png"
            alt=""
          />
        </div>
      </div>
    </section>
  );
};
